import { gameState } from "appworks/model/game-state";
import { wrapperImplementation } from "gameiom/wrapper/wrapper-implementation";
import { AgsHighlightWinsState } from "./ags-highlight-wins-state";

export class AgsFreespinsTriggeredHighlightWinsState extends AgsHighlightWinsState {
    public onEnter(): void {
        super.onEnter();
    }

    public complete(): void {
        const win = gameState.getCurrentGame().getTotalWin();
        wrapperImplementation.onResume.addOnce(() => super.complete());
        gameWrapper.balancesUpdate(
            gameState.getCurrentGame().realBalance,
            gameState.getCurrentGame().freeBalance
        );
        gameWrapper.winningsUpdate(win);
    }
}
